import { gql } from '@apollo/client';

export const GET_ALL_TENDER_USERS_QUERY = gql`
  query participants {
    get(tenderId: $tenderId)
      @rest(
        type: "TenderParticipants"
        path: "/tenders/{args.tenderId}/getAllUsers"
        endpoint: "etendering"
      ) {
        bidId
        createdDate
        description
        id
        status
        userRole
        user
    }
  }
`;
